import {observer} from "mobx-react";
import CheckboxFilter from "./CheckboxFilter";
import {useStore} from "../../../stores/Store";

export default observer(function ChinSwitchesFilter(){
    const {LanguageStore, AccordionStore} = useStore();
    const {currentLanguageMessages} = LanguageStore;
    const {setFilteredChinSwitches, filteredChinSwitches, findDistinctChinSwitches} = AccordionStore;

    const createCheckObjects = () => {
        const co: {value: number, label: string}[] = [];
        findDistinctChinSwitches().map(v => co.push({value: v, label: v.toString()}));
        return co;
    }

    return (
        <CheckboxFilter
            title={currentLanguageMessages.AccordionsPage.Filter.ChinSwitches.title}
            filteredValue={filteredChinSwitches}
            setFilteredValue={setFilteredChinSwitches}
            checkObjects={createCheckObjects()}
            attributeName={'chinSwitches'}
        />
    )
})